import React, { useEffect, useState, Fragment } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import EcoIcon from "@material-ui/icons/Eco";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import { green } from "@material-ui/core/colors";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import CountUp from "react-countup";
import services from "../services";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 14,
  },
  card4: {
    borderRadius: "10px",
    backgroundColor: "#fffff",
    paddingInlineStart: "10px",
    boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

    height: 250,
  },
}));

const GreenRadio = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export const CollectionCount = (props) => {
  const [selectedValue, setSelectedValue] = useState([]);
  const [radioButtonValue, setRadioButtonValue] = useState();
  const classes = useStyles();

  const { id } = props;

  useEffect(() => {
    getDailyCollectionCount();
  }, []);

  async function getDailyCollectionCount() {
    const result = await services.getCollectionCountByType(id, 3);
    setSelectedValue(result);
    setRadioButtonValue(1);
  }

  async function getMonthlyCollectionCount() {
    const result = await services.getCollectionCountByType(id, 2);
    setSelectedValue(result);
    setRadioButtonValue(2);
  }

  async function getYearlyCollectionCount() {
    const result = await services.getCollectionCountByType(id, 1);
    setSelectedValue(result);
    setRadioButtonValue(3);
  }

  function handleClickCheckbox(e) {
    e.stopPropagation();
  }

  return (
    <Card className={classes.card4} boxShadow={3}>
      <CardContent>
        <Typography
          className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          <b>Collection Count</b>
        </Typography>

        <Typography
          className={classes.title}
          color="textSecondary"
          display="inline"
        >
          <RadioGroup
            row
            aria-label="position"
            name="position"
            defaultValue="top"
          >
            <FormControlLabel
              value="top"
              control={
                <GreenRadio
                  checked={radioButtonValue === 1}
                  onChange={getDailyCollectionCount}
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "C" }}
                  onClick={(e) => handleClickCheckbox(e)}
                />
              }
              label="Daily"
              labelPlacement="top"
            />

            <FormControlLabel
              value="top"
              control={
                <GreenRadio
                  checked={radioButtonValue === 2}
                  onChange={getMonthlyCollectionCount}
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "C" }}
                />
              }
              label="Monthly"
              labelPlacement="top"
            />

            <FormControlLabel
              value="top"
              control={
                <GreenRadio
                  checked={radioButtonValue === 3}
                  onChange={getYearlyCollectionCount}
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "C" }}
                />
              }
              label="Yearly"
              labelPlacement="top"
            />
          </RadioGroup>

          <List>
            {selectedValue.map((s) => {
              return (
                <ListItem>
                  <ListItemIcon>
                    <EcoIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={s.collectionTypeName} />
                  <ListItemSecondaryAction>
                    <CountUp
                      end={s.totalAmount}
                      decimals={2}
                      decimal="."
                      suffix="Kg"
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </Typography>
      </CardContent>
    </Card>
  );
}
